<script>
import { ref, onMounted, toRefs, watch, computed, reactive } from "vue";
import { useScrollEffect } from "../functions";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop"],
	setup(props) {
		const { windowWidth, windowHeight, scrollTop } = toRefs(props);

		const container = ref(null);
		const img = ref(null);
		const mainTitle = ref(null);
		const cover = ref(null);
		const mask = ref(null);

		const containerHeight = ref(0);
		const imgSrc = reactive({
			pc: require("../assets/background_c2.jpg"),
			mobile: require("../assets/background_c2_mobile.jpg"),
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});

		// const imgCoeff = useScrollEffect(
		// 	0.33 * windowHeight.value,
		// 	windowHeight.value,
		// 	17,
		// 	0
		// );
		const containerCoeff = useScrollEffect(
			-100,
			windowHeight.value,
			100,
			0
		);
		const smallTransfromCoeff = useScrollEffect(
			1 * windowHeight.value,
			3 * windowHeight.value,
			0,
			-30
		);
		const mainTitleCoeff = useScrollEffect(
			0.33 * windowHeight.value,
			windowHeight.value,
			-0.5,
			1.1
		);
		const coverCoeff = useScrollEffect(
			1.1 * windowHeight.value,
			1.7 * windowHeight.value,
			-0.5,
			1.1
		);

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
			});
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (
					innerHeight.value > -100 &&
					innerHeight.value < windowHeight.value
				) {
					// if (windowWidth.value > 650) {
					// 	img.value.style.top = `${nv * imgCoeff.a + imgCoeff.b}%`;
					// } else {
					// 	img.value.style.top = `calc(${nv * imgCoeff.a + imgCoeff.b}% - 10px)`;
					// }
					container.value.style.backgroundPosition = `center calc(50%${
						windowWidth.value <= 650 ? " - 12vw" : ""
					} + ${nv * containerCoeff.a + containerCoeff.b}px)`;
				} else if (
					innerHeight.value > 1 * windowHeight.value &&
					innerHeight.value < 3 * windowHeight.value
				) {
					container.value.style.transform = `translateY(${nv *
						smallTransfromCoeff.a +
						smallTransfromCoeff.b}px)`;
				} else if (innerHeight.value >= 3 * windowHeight.value) {
					// container.value.style.transform = `translateY(${3 *
					// 	windowHeight.value *
					// 	smallTransfromCoeff.a +
					// 	smallTransfromCoeff.b}px)`;
				} else {
					if (windowWidth.value > 650) {
						//img.value.style.top = "0";
					} else {
						//img.value.style.top = "-10px";
					}
					// container.value.style.transform = "translateY(0px)";
				}

				if (innerHeight.value > 0.33 * windowHeight.value) {
					mainTitle.value.style.opacity = `${nv * mainTitleCoeff.a +
						mainTitleCoeff.b}`;
					mask.value.style.opacity = `${nv * mainTitleCoeff.a +
						mainTitleCoeff.b}`;
				} else {
					mainTitle.value.style.opacity = 0;
					mask.value.style.opacity = 0;
				}

				if (innerHeight.value > 1.1 * windowHeight.value) {
					cover.value.style.opacity = `${nv * coverCoeff.a +
						coverCoeff.b}`;
				} else {
					// cover.value.style.opacity = 0;
				}
			}
		);
		return {
			container,
			windowWidth,
			imgSrc,
			img,
			cover,
			mainTitle,
			mask,
		};
	},
};
</script>

<template>
	<section id="conception">
		<img
			:src="windowWidth > 650 ? imgSrc.pc : imgSrc.mobile"
			alt="全新BMW 4系列家族豪華跑車"
		/>
		<div
			class="bg_c6 sticky-wrapper"
			ref="container"
			:style="{
				backgroundImage: `url(${
					windowWidth > 650 ? imgSrc.pc : imgSrc.mobile
				})`,
			}"
		>
			<div class="contain-img"></div>
			<div class="main-cover">
				<h2 class="title_main text_ch_medium shine" ref="mainTitle">
					<span class="inner_title_main">前衛美學 不容錯</span>
					<span>認</span>
				</h2>
			</div>
			<div class="mask" ref="mask"></div>
			<div class="cover" ref="cover"></div>
		</div>
	</section>
	<section id="conception-text">
		<div class="sticky-wrapper">
			<p class="title_sub text_ch_medium">
				<span
					>凌厲鋒芒，一見入迷！ <br class="mobile_break" /><span
						class="text_en_bold"
						>BMW 4 </span
					>系列家族巔峰之作，</span
				>
				<br /><span
					>全新<span class="text_en_bold"> THE 4 Gran Coupé </span
					>豪華四門跑車，</span
				><br />
				<span
					>以雙門跑車般的優雅流線，搭配過目難忘的搶眼設計，
					<br class="mobile_break" />
					大展風靡世人的獨到鋒采！</span
				>
			</p>
		</div>
	</section>
</template>

<style lang="sass" scoped>
#conception
    // z-index: 63
    z-index: 55
    background-color: #010b24
    // background-color: #111
    img
        display: none
    .bg_c6
        width: 100%
        background-size: cover
        background-repeat: no-repeat
        background-position: center calc(50% + 100px)
        // background-position: center calc(50% + 100px + 100.02vw - 509.2px)
        .contain-img
            display: none
            position: absolute
            width: 100%
            height: 35px
            bottom: -35px
            background-color: #010b24
            // background-image: linear-gradient(to right, rgba(210,17,51,1) 0%, rgba(184,23,57,1) 20%, rgba(184,23,57,1) 100%)
            background-size: 100% 35px
            -webkit-background-size: 100% 35px
            -moz-background-size: 100% 35px
            -o-background-size: 100% 35px
            background-position: center bottom
            background-repeat: no-repeat
            z-index: 90
        .cover
            position: absolute
            width: 100%
            height: calc(72.95% + 30px)
            left: 0
            bottom: -5px
            opacity: 0
            background-image: linear-gradient(180deg, rgba(242, 0, 56, 0) 0%, rgba(213, 1, 54, 0.4) 15%, rgba(1, 11, 36, 1) 75%)
        .main-cover
            position: relative
            width: 90%
            // height: 34px
            margin: 0 auto
            top: 72%
            z-index: 90
            text-align: center
            overflow: hidden
            h2
                position: relative
                width: 100vw
                left: 50%
                transform: translateX(-50%)
                text-align: center
                font-size: 3rem
                line-height: 3.27
                color: #999
                opacity: 0
                span
                    letter-spacing: normal
                    font-size: inherit
                    // color: #999
                    &.inner_title_main
                        letter-spacing: 31.2px
                &.shine
                        animation: shine2 4s infinite linear forwards
        .mask
            position: absolute
            left: 50%
            top: 72.5%
            width: 40vw
            max-width: 675px
            border-radius: 50%
            height: 32px
            transform: translate(-50%, 46%)
            -webkit-filter: blur(14.8px)
            filter: blur(14.8px)
            background-color: rgba(#740000, 1)
            opacity: 0
            // z-index: 10

@keyframes shine2
    0%
        background-position: 0vw 10px
    100%
        background-position: 100vw 10px

#conception-text
    // z-index: 60
    // z-index: 63
    z-index: 55
    .sticky-wrapper
        width: 100%
        .title_sub
            position: relative
            top: calc(72% + 80px)
            font-size: 1.5rem
            line-height: 2.4
            letter-spacing: 2.84px
            text-align: center
            z-index: 70
            span
                font-size: inherit
            .mobile_break
                display: none

@media screen and (min-width: 1441px)
    #conception
        .bg_c6
            .main-cover
                top: calc(50% + 18.7vw + 56.2px)
                transform: translate(0%, calc(-50% - (18.7vw + 56.2px) / 2))
            .mask
                top: calc(50% + 18.7vw + 56.2px)
                transform: translate(-50%, calc(-50% - (18.7vw + 56.2px) / 2))
    #conception-text
        .sticky-wrapper
            .title_sub
                top: calc(50% + 12.7vw + 56.2px - 20px)
@media screen and (min-width: 1200px)
    #conception
        .bg_c6
            .mask
                height: 43px
@media screen and (max-width: 1440px)
    #conception
        .bg_c6
            .main-cover
                transform: scale(0.9)
            .mask
                transform: translate(-50%, 46%) scale(0.9)
    #conception-text
        .sticky-wrapper
            .title_sub
                transform: scale(0.9)
@media screen and (max-width: 1200px)
    #conception
        .bg_c6
            .title_main
                // transform: scale(1)
            .mask
                // transform: translate(-50%, 46%) scale(1)
                transform: translate(-50%, 46%) scale(0.9)
                width: 512px
    #conception-text
        .sticky-wrapper
            .title_sub
                transform: scale(1)
@media screen and (max-width: 768px)
    #conception
        .bg_c6
            .main-cover
                h2
                    line-height: 2.5
                    span
                        font-size: 1.8rem
                        &.inner_title_main
                            letter-spacing: 9.6px
            .mask
                // top: 59.2%
    #conception-text
        .sticky-wrapper
            .title_sub
                font-size: 1.2rem
                line-height: 2.17
                letter-spacing: 1.44px
                .mobile_break
                    display: block
                    &.comma
                        display: inline
                .pc_break
                    display: none
@media screen and (max-width: 650px)
    #conception
        background-color: #111
        .bg_c6
            background-size: 100% auto
            // background-position: center calc(50% - 20px)
            background-position: center calc(50% - 12vw + 100px)
            .contain-img
                display: block
            .main-cover
                top: calc(2.6vw + 300px + 52.7% - 367px)
            .mask
                max-width: 400px
                width: 77vw
                top: calc(2.6vw + 300px + 52.7% - 367px)
                transform: translate(-50%, 78%)
    #conception-text
        .sticky-wrapper
            .title_sub
                top: calc(2.6vw + 310px + 146.2px + 51.9% - 361.6px)
@media screen and (max-height: 600px)
    #conception-text
        .sticky-wrapper
            .title_sub
                top: calc(2.6vw + 310px + 146.2px + 51.9% - 361.6px - 60px)
</style>
